module.exports = __webpack_public_path__ + "static/6-0f8a7a81690bfed474f38607928557a3.jpeg";